import { isValidObject } from '@airtel/air-design-system';
export var layoutWrapperContainerIds = ['[data-testid="Header"]', '[data-testid="artist-grid-container"]', '[data-testid="artist-sticky-footer"]', '[data-testid="artist-banner-container"]', '[data-testid="Footer"]'];
export var getOmniWidgetInteractionActionData = (event, onWidgetInteraction) => {
  var _a, _b, _c, _d;
  var response = {};
  if ((event === null || event === void 0 ? void 0 : event.eventName) === 'WtoC_Widget_loaded' && isValidObject(onWidgetInteraction === null || onWidgetInteraction === void 0 ? void 0 : onWidgetInteraction.onLoadWidget)) {
    response = onWidgetInteraction === null || onWidgetInteraction === void 0 ? void 0 : onWidgetInteraction.onLoadWidget;
  }
  if ((event === null || event === void 0 ? void 0 : event.eventName) === 'WtoC_Modal_Open' && (event === null || event === void 0 ? void 0 : event.screenName) === 'ADD_ADDRESS_SCREEN' && isValidObject(onWidgetInteraction === null || onWidgetInteraction === void 0 ? void 0 : onWidgetInteraction.onLoadAddressModal)) {
    response = onWidgetInteraction === null || onWidgetInteraction === void 0 ? void 0 : onWidgetInteraction.onLoadAddressModal;
  }
  if ((event === null || event === void 0 ? void 0 : event.eventName) === 'WtoC_UserInteraction' && ((_a = event === null || event === void 0 ? void 0 : event.userData) === null || _a === void 0 ? void 0 : _a.id)) {
    var userEventIdMapping = {};
    if (((_b = event === null || event === void 0 ? void 0 : event.userData) === null || _b === void 0 ? void 0 : _b.type) === 'onSelect') {
      userEventIdMapping = {
        currentLocationText: 'onClickCurrentLocation',
        manualAddressText: 'onClickManualAddress',
        city: 'onSelectCity',
        pincodeInput: 'onSelectPinCode',
        suggestionsListSearchAddressScreen: 'onSelectAddress',
        suggestionsList: 'onSelectAddress',
        submitSavedAddress: 'onSavingManualAddress'
      };
    }
    if (((_c = event === null || event === void 0 ? void 0 : event.userData) === null || _c === void 0 ? void 0 : _c.type) === 'onValid') {
      userEventIdMapping = {
        pincodeInput: 'onValidPinCode'
      };
    }
    var interactionId = userEventIdMapping[(_d = event === null || event === void 0 ? void 0 : event.userData) === null || _d === void 0 ? void 0 : _d.id];
    var interactionData = onWidgetInteraction === null || onWidgetInteraction === void 0 ? void 0 : onWidgetInteraction[interactionId];
    if (isValidObject(interactionData)) {
      response = interactionData;
    }
  }
  return response;
};